import {type ITableHeaderProps} from 'shared/TableDataContainer'
import {type ITEParameterIDMapProps, type ITxnErrorStructProps, type ITxnErrorsChartProps} from './ac-opsdash.types'

const CHART_SUCCESS_COLOR = '#f6f9fc'
const CHART_ERROR_COLOR = '#c94346'

export const TE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS'

export const DEFAULT_TXN_ERRORS_STATE: ITxnErrorStructProps = {
    totalTransaction: 0,
    normalCount: 0,
    errorCount: 0,
    normalCountPercent: 0,
    errorCountPercent: 0,
    errorTransactions: [],
    transactionErrorCount: [],
    error: null,
    isLoading: true
}

export const DEFAULT_TXN_ERRORS_TABLE_HEADERS: ITableHeaderProps[] = [
    {
        id: 'errorPercent',
        headerLabel: 'Percent',
        customCellClassName: 'percent-col',
        align: 'left'
    },
    {
        id: 'errorDescription',
        headerLabel: 'Error description',
        customCellClassName: 'description-col',
        align: 'left'
    },
    {
        id: 'errorCount',
        headerLabel: 'Count',
        customCellClassName: 'count-col',
        align: 'right'
    }
]

export const TE_CHART_DATA: ITxnErrorsChartProps[] = [
    {
        id: 'normalCount',
        percentId: 'normalCountPercent',
        label: 'Success',
        valueType: 'normal',
        value: 0,
        color: CHART_SUCCESS_COLOR
    },
    {
        id: 'errorCount',
        percentId: 'errorCountPercent',
        label: 'Errors',
        valueType: 'errors',
        value: 0,
        color: CHART_ERROR_COLOR
    }
]

export const TE_CHART_OPTIONS = [
    {
        bgColor: CHART_SUCCESS_COLOR,
        labelColor: CHART_SUCCESS_COLOR,
        label: 'Success',
        id: 'normalCount',
        pattern: 'lines'
    },
    {
        bgColor: CHART_ERROR_COLOR,
        labelColor: CHART_ERROR_COLOR,
        label: 'Errors',
        id: 'errorCount',
        pattern: 'dots'
    }
]

export const TE_PARAMETERS = {
    booking: 'BKG',
    awbCreation: 'MAWB',
    availAndPrice: 'ADVRATE',
    avail: 'AVAIL'
}

export const TE_PARAMETER_ID: Map<string, ITEParameterIDMapProps> = new Map()
    .set(TE_PARAMETERS.booking, {portalFunction: TE_PARAMETERS.booking, reduxId: 'booking', label: 'Booking'})
    .set(TE_PARAMETERS.awbCreation, {
        portalFunction: TE_PARAMETERS.awbCreation,
        reduxId: 'awbCreation',
        label: 'AWB Creation'
    })
    .set(TE_PARAMETERS.availAndPrice, {
        portalFunction: TE_PARAMETERS.availAndPrice,
        reduxId: 'availAndPrice',
        label: 'Availability & Price'
    })
    .set(TE_PARAMETERS.avail, {
        portalFunction: TE_PARAMETERS.avail,
        reduxId: 'availAndPrice',
        label: 'Availability & Price'
    })
